<template>
  <div class="changePwd">
    <Card class="card">
      <!-- <div class="topTit">
        <p>修改密码</p>
      </div> -->
      <Form class="forms" ref="formUser" :rules="ruleCustom" :model="form" :label-width="100">
        <FormItem class prop="oldPassword" label="原密码">
          <Input
            class="inputPassword"
            type="password"
            v-model="form.oldPassword"
            v-filter-space
            placeholder="请输入原密码"
          ></Input>
        </FormItem>
        <!-- 新密码的隐藏与显示 -->
        <FormItem v-if="flag" label="新密码:" prop="password">
          <Input v-filter-space class="inputPassword" type="password" placeholder="请输入新密码" v-model="form.password">
            <Icon @click="handlePassword" type="ios-eye-off-outline" size="22" slot="suffix"/>
          </Input>
        </FormItem>
        <FormItem v-else label="新密码:" prop="password">
          <Input v-filter-space class="inputPassword" type="text" placeholder="请输入新密码" v-model="form.password">
            <Icon @click="handlePassword" type="ios-eye-outline" size="22" slot="suffix"/>
          </Input>
        </FormItem>
        <!-- 确认密码的隐藏与显示 -->
        <FormItem v-if="flag1" label="确认密码:" prop="confirmPassword">
          <Input
            class="inputPassword"
            type="password"
            v-filter-space
            placeholder="请输入确认密码"
            v-model="form.confirmPassword"
            @blur.native.capture="onChange"
          >
            <Icon @click="handlePassword1" type="ios-eye-off-outline" size="22" slot="suffix"/>
          </Input>
        </FormItem>
        <FormItem v-else label="确认密码:" prop="confirmPassword">
          <Input
            class="inputPassword"
            type="text"
            placeholder="请输入确认密码"
            v-model="form.confirmPassword"
            v-filter-space
            @blur.native.capture="onChange"
          >
            <Icon @click="handlePassword1" type="ios-eye-outline" size="22" slot="suffix"/>
          </Input>
        </FormItem>

        <!-- <FormItem class="userloginform-codeinput" prop="captcha" label="图片验证码">
          <Row :gutter="10" class="code">
            <Col class="inputCode">
              <Input v-filter-space v-model="form.captcha" placeholder="请输入验证码"></Input>
            </Col>
            <Col>
              <p class="codeBox">
                <img :src="`${baseURL}/auth/captcha?p=${captchaNum}`" @click="++captchaNum">
              </p>
            </Col>
          </Row>
        </FormItem> -->
        <FormItem class="btns">
          <Button class="btn1" type="primary" @click="changePwds">保存</Button>
          <Button class="btn1" @click="link('/user/account/infoIndex/info')">取消</Button>
        </FormItem>
      </Form>
    </Card>
  </div>
</template>

<script>
import { changeUserPwd } from "@/api/user"; //获取用户信息

export default {
  name: "ChangePwd",
  data() {
    return {
      ruleCustom: {
        oldPassword: [
          {
            required: true,
            message: "请输入原始密码",
            trigger: "blur"
          }
        ],
        password: [
          {
            required: true,
            validator: _FORM.pwd_len,
            max_len: 16,
            min_len: 6,
            trigger: "blur",
            label: "新密码"
          }
        ],
        confirmPassword: [
          {
            required: true,
            validator: _FORM.repwd_len,
            pass: "zz",
            min_len: 6,
            max_len: 16,
            trigger: "blur",
            label: "确认密码"
          }
        ],
        captcha: [
          {
            required: true,
            trigger: "blur",
            message: "请输入验证码"
          }
        ]
      },
      form: {
        oldPassword: "",
        password: "",
        confirmPassword: "",
        captcha: ""
      },
      baseURL: "/services/free",
      captchaNum: 0,
      flag: true,
      flag1: true
    };
  },
  created() {},
  methods: {
    // 赋值（确认密码的比较*）
    onChange() {
      this.ruleCustom.confirmPassword[0].pass = this.form.password;
    },
    handlePassword() {
      this.flag = !this.flag;
    },
    handlePassword1() {
      this.flag1 = !this.flag1;
    },
    link(path) {
      //  this.$Message.success("撤回成功");
      this.$router.push({ path: path });
    },
    changePwds() {
      console.log("form", this.form);
      this.$refs.formUser.validate(valid => {
        if (valid) {
          changeUserPwd(this.form)
            .then(res => {
              this.$Message.success("密码修改成功");
              this.$nextTick(() => {
                _Cookie.remove("adminauth");
              })
              console.log("填写的表单信息", res);
              this.$router.push({
                path: "/user/account/infoIndex/ChangePwdOk"
              });
            })
            .catch(err => {
              this.captchaNum++;
              console.log("接口请求失败", err);
            });
        } else {
          console.log("请正确填写表单信息");
        }
      });
    }
  }
};
</script>

<style lang="scss">
.changePwd {
  width: 100%;
  .card {
    width: 100%;
    min-height: calc(100vh - 150px);
    font-size: 14px;
    color: #2f4061;
    // .topTit {
    //   width: 100%;
    //   font-size: 16px;
    //   font-family: MicrosoftYaHeiSemibold;
    //   color: #2f4061;
    //   font-weight: bold;
    //   border-bottom: 1px solid #ebedf0;
    //   box-sizing: border-box;
    //   padding: 10px 0px;
    // }
    .forms {
      margin-top: 20px;
      width: 45%;
      .inputPassword {
        width: 410px;
      }
      .code {
        display: flex;
        flex-wrap: nowrap;
        .inputCode {
          min-width: 290px;
          flex-shrink: 0;
        }
        .codeBox {
          margin-left: auto;
          width: 110px;
          height: 36px;
          background: #f4f4f4;
          border-radius: 4px;
          display: flex;
          justify-content: center;
          align-items: center;
          img {
            width: 108px;
            height: 34px;
          }
        }
      }
    }
    .title {
      font-size: 24px;
      font-family: MicrosoftYaHei;
      color: #2f4061;
      text-align: center;
      margin-top: 30px;
    }
    .btns {
      display: flex;
      .btn1 {
        border-radius: 20px;
        width: 100px;
      }
      .btn1:first-child {
        margin-right: 140px;
      }
    }
  }
}
</style>